import React from "react";
import SubLayout from "../SubLayout/SubLayout";
import { IconImage, IconArrowRight } from "../icons/Icons";

const INSTAGRAM_URL = "https://www.instagram.com/sublimebarberia/";

function Trabajos() {
    return (
        <SubLayout
            icon={IconImage}
            title="Trabajos Realizados"
            intro="Echa un vistazo a algunos de nuestros trabajos."
            centered
        >
            <div className="ig-embed">
                {/* WIDGET INSTAGRAM: sustituye este bloque por el <iframe> de LightWidget / SnapWidget */}
                <div className="ig-ph">
                    <strong>Feed de Instagram</strong>
                    <span>
                        Pega aquí el código embed de @sublimebarberia para mostrar las
                        fotos en vivo.
                    </span>
                </div>
            </div>

            <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="full-link"
            >
                Ver más trabajos
                <IconArrowRight />
            </a>
        </SubLayout>
    );
}

export default Trabajos;
